import Icon from "@mui/material/Icon";
import Logout from "@mui/icons-material/Logout";
import Task from "@mui/icons-material/Task";
import Person from "@mui/icons-material/Person";
import Info from "@mui/icons-material/InfoOutlined";
import LogOut from "./pages/LandingPages/LogOut/LogOut";

const routes = [
  {
    name: "Home",
    icon: <Icon>home</Icon>,
    route: "/app/trainerdashboard",
  },
  {
    name: <span style={{ fontWeight: 'bold' }}>Edit Profile</span>,
    name: "Edit Profile",
    icon: <Person />,
    route: `/app/trainerprofileedit/${localStorage.getItem("userId")}`,
  },
  {
    name: "Trainings",
    icon: <Task />,
    route: "/app/traininglistindex",
  },
  {
    name: "Pending Actions",
    icon: <Info />,
    route: "/app/trainerpendingaction",
  },
  {
    name: "LogOut",
    route: "/app/logout",
    component: <LogOut />,
    icon: <Logout />,
  },
];

export default routes;
